"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var itemsList_1 = require("../itemsList");
var Option = /** @class */ (function (_super) {
    tslib_1.__extends(Option, _super);
    function Option(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onSelectItem = function (value, label) {
            var onSelect = _this.context.onSelect;
            onSelect && onSelect(value);
        };
        return _this;
    }
    Option.prototype.render = function () {
        var _a = this.props, className = _a.className, active = _a.active, label = _a.label, value = _a.value, selected = _a.selected, others = tslib_1.__rest(_a, ["className", "active", "label", "value", "selected"]);
        return (React.createElement(itemsList_1.ListItem, tslib_1.__assign({}, others, { label: label, value: value, className: className, active: active, selected: selected, onItemSelect: this.onSelectItem })));
    };
    Option.defaultProps = {};
    Option.contextTypes = {
        onSelect: PropTypes.func
    };
    return Option;
}(React.Component));
exports.default = Option;
